import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#378595',
        error: '#D32F2F',
        warning: '#e36013',
        cancel: '#8f8f8f',
        /* secondary: '#b0bec5',
          accent: '#90A4AE',
          error: '#b71c1c',
          primaryred: '#B71C1C',
          secondaryyred: '#EF9A9A', */
      },
    },
  },
});
